import React from 'react';
import styles from './styles.module.scss';
import cx from 'classnames';
const LOGO = '/images/seek.gif';

interface Props {
    isHistory: boolean;
    onExitHistory: () => void;
    onOpenHistory: () => void;
}

const Header: React.FC<Props> = ({ isHistory, onExitHistory, onOpenHistory }) => {
    return (  <div className={styles.agentHeader}>
                <div className={styles.brand}>
                    <img className={styles.logo} src={LOGO} alt="" />
                    <p className={styles.title}>deal agent</p>
                </div>
            
    </div>
)};

export default Header;
